import SectionHeading from "@/components/base/SectionHeading";
import { siteInfo } from "@/mocks/home";

const points = [
  {
    icon: "ri-search-eye-line",
    title: "先理清，再看剧",
    desc: "把多线叙事拆成清晰条目，人物动机和事件顺序一次讲明白。",
  },
  {
    icon: "ri-links-line",
    title: "对照人物关系",
    desc: "每条人物线单独成条，谁隐瞒了谁、谁又替谁掩护，一目了然。",
  },
  {
    icon: "ri-refresh-line",
    title: "随更新同步",
    desc: "新集上线后补齐故事梗概与解析，追剧进度始终跟得上。",
  },
];

export default function OverviewSection() {
  return (
    <section id="overview" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="剧情速览"
          title="先看懂故事梗概，再决定从哪一集入坑"
          desc={siteInfo.intro}
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {points.map((item) => (
            <article
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-4 rounded-lg border border-accent-200 bg-accent-50 p-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-alert-line text-lg"></i>
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-950">故事梗概不含关键剧透</h3>
              <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                分集介绍只点到线索与氛围，把最终反转留给你自己看，适合还没追完的观众。
              </p>
            </div>
          </div>
          <a
            href="#characters"
            className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
          >
            查看角色图谱
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}